enum SummarizedFulfillmentState {
  Allocating = 'allocating',
  Pending = 'pending',
  Failed = 'failed',
  Succeeded = 'succeeded',
}

export default SummarizedFulfillmentState;
